/*
 * @description:
 * @author: cuicui
 * @Date: 2023-01-20 00:11:06
 * @LastEditTime: 2025-09-04 09:48:42
 * @LastEditors: fusiyuan 1152054863@qq.com
 */
export const STATUS = {
  waitAudit: "waitAudit",
  finished: "finished",
  nopass: "nopass",
};
export const STATUS_zh = {
  failed: "登记失败",
  waitAudit: "待审核",
  finished: "登记成功",
  nopass: "登记失败",
  failure: "登记失败", // 审核失败
  inProgress: "登记失败", // 进行中
};
export const TYPE = {
  PERSONAL: "PERSONAL",
  ENTERPRISE: "ENTERPRISE",
};
export const TYPE_zh = {
  PERSONAL: "个人身份认证",
  ENTERPRISE: "企业资质认证",
};
